import { Component, OnInit, OnDestroy, Renderer2, Input } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { AdditionalData } from './AdditionalData';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
	selector: 'app-staffrecruitment',
	templateUrl: './staffrecruitment.component.html',
	styleUrls: ['./staffrecruitment.component.scss'],
	providers: [MessageService]
})
export class StaffrecruitmentComponent implements OnInit {
	msgs: Message[] = [];
	generalInformationForm: FormGroup;
	minDateOfBirth: Date;
	maxDateOfBirth: Date;
	dateOfBirth: Date;
	maxDateOfBirthYear: number;
	minDateOfBirthYear: number;
	dataList: any;
	boardName: any;
	cdt: any;
	fm: any;
	tm: any;
	dbm: any;
	dby: any;
	displayForm: boolean;
	public genderList = [];
	public genericList = [];
	public categoryList = [];
	public postcategoryList = [];
	public departList = [];
	public distList = [];
	public phycalHList = [];
	public postlist = [];
	public subjectSPLList = [];
	public boardList = [];
	public examList = [];
	public yearList = [];
	public emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
	public expList = [];
	public acaList = [];
	public staffDetailsInfo = [];
	public typeofEmplpyment = [];
	scrollHeight: string = '400px';
	distName: any;
	academicdetailList: any;
	acaDetailsInfo: {
		academicyr: any,
		edudetail: any,
		exampass: any,
		id: any,
		parent_id: any,
		marks: any,
		subjectstudied: any,
		otherinfo: any,
		division: any
	}[];
	expDetailsInfo: {
		id: any,
		parent_id: any,
		fromdate: any,
		todate: any,
		instituteName: any,
		yearcount: any,
		typeofemployee: any,
		monthcount: any
	}[];
	rowData: any;
	processbar: boolean = false;
	user_id: any;
	designationId: any;
	postcategoryid: any;
	departmentId: any;
	showdeleteBtn: boolean = false;
	advid: any;
	advName: any;
	showdept: boolean = false;
	constructor(private formBuilder: FormBuilder, private registrationService: RegistrationService, private router: Router) { }
	@Input() additionaldata: AdditionalData;
	ngOnInit() {
		this.user_id = localStorage.getItem('member-id');
		this.genderList = [
			{
				'id': 'Male',
				'name': 'Male'
			}, {
				'id': 'Female',
				'name': 'Female'
			}, {
				'id': 'Third Gender',
				'name': 'Third Gender'
			}
		];

		this.genericList = [
			{
				'id': 1,
				'name': 'NO'
			}, {
				'id': 2,
				'name': 'YES'
			}
		];
		this.typeofEmplpyment = [
			{
				'id': 'PERMANENT',
				'name': 'PERMANENT'
			}, {
				'id': 'CONTRACTUAL',
				'name': 'CONTRACTUAL'
			}, {
				'id': 'GUEST LECTURER',
				'name': 'GUEST LECTURER'
			}
			, {
				'id': 'PART TIME',
				'name': 'PART TIME'
			}
		];
		this.additionaldata = new AdditionalData;
		this.additionaldata.academicData = [
			{
				academicyr: '',
				edudetail: '',
				exampass: '',
				id: '',
				parent_id: '',
				marks: '',
				subjectstudied: '',
				otherinfo: '',
				division: ''
			}
		];
		this.additionaldata.experienceData = [
			{
				id: '',
				parent_id: '',
				fromdate: '',
				todate: '',
				instituteName: '',
				yearcount: '',
				typeofemployee: '',
				monthcount: ''
			}
		];
		const TODAY = new Date();
		const MONTH = TODAY.getMonth();
		const YEAR = TODAY.getFullYear();

		this.maxDateOfBirthYear = YEAR;
		this.minDateOfBirthYear = YEAR - 60;

		this.minDateOfBirth = new Date();
		this.minDateOfBirth.setMonth(MONTH);
		this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);

		this.maxDateOfBirth = new Date();
		this.maxDateOfBirth.setMonth(MONTH);
		this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);

		this.dateOfBirth = this.maxDateOfBirth;
		this.advid = localStorage.getItem('advId');
		this.advName = localStorage.getItem('advName');
		//this.getAllCommonList();
		this.getAllCandidateList();
	}
	getAllCommonList() {
		this.processbar = true;
		console.log('getAllCommonList==================');
		this.registrationService.getCommonList(this.advid).then(res => {
			console.log(res);
			this.dataList = res;
			this.categoryList = this.dataList.categoryList;
			this.postcategoryList = this.dataList.postcategoryList;
			this.departList = this.dataList.departList;
			this.distList = this.dataList.distList;
			this.phycalHList = this.dataList.phycalHList;
			this.postlist = this.dataList.postlist;
			this.subjectSPLList = this.dataList.subjectSPLList;
			this.boardList = this.dataList.boardList;
			this.examList = this.dataList.examList;
			this.yearList = this.dataList.yearList;
			this.yearList.push({ id: '-1', name: 'Select' });
			this.processbar = false;

		});
	}
	getPrintCommonList() {
		this.designationId = 0;
		this.postcategoryid = 0;
		this.departmentId = 0;
		this.registrationService.getCommonList(this.advid).then(res => {
			this.dataList = res;
			this.postcategoryList = this.dataList.postcategoryList;
			this.departList = this.dataList.departList;
			this.postlist = this.dataList.postlist;
		});
	}
	getAllCandidateList() {
		this.getPrintCommonList();
		this.processbar = true;
		let id = localStorage.getItem('member-id');
		this.registrationService.getAllCandidateList(id, this.advid).then(res => {
			console.log(res);
			this.dataList = res;
			this.staffDetailsInfo = this.dataList.allStaffDetails;
			this.processbar = false;
		});
	}

	_keyPress(event: any) {
		const pattern = /[0-9\+\-\.\ ]/;
		let inputChar = String.fromCharCode(event.charCode);

		if (!pattern.test(inputChar)) {
			event.preventDefault();
		}
	}

	savestaffData() {
		if (this.additionaldata.applicationNo == null || this.additionaldata.applicationNo == '') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Applicant Receipt No.' });
			return false;
		}
		if (this.additionaldata.designationId == null || this.additionaldata.designationId == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		// if (this.advid != 1) {
		// 	if (this.additionaldata.departmentId == null || this.additionaldata.departmentId == 0) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		if (this.additionaldata.postcategoryid == null || this.additionaldata.postcategoryid == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		if (this.additionaldata.name == null || this.additionaldata.name == '') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Applicant Name' });
			return false;
		}
		if (this.additionaldata.email == null || this.additionaldata.email == '') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Email' });
			return false;
		}
		if (!this.validateEmail(this.additionaldata.email)) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Valid Email' });
			return false;
		}
		if (this.additionaldata.dob == null || this.additionaldata.dob == '') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Date of Birth' });
			return false;
		}

		if (this.additionaldata.mobile == null || this.additionaldata.mobile == '' || this.additionaldata.mobile.length < 10) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter 10 Digit Mobile No.' });
			return false;
		}

		if (this.additionaldata.sex == null || this.additionaldata.sex == '0') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Gender' });
			return false;
		}

		if (this.additionaldata.categoryId == null || this.additionaldata.categoryId == '0') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Category' });
			return false;
		}
		if (this.additionaldata.phid == null || this.additionaldata.phid == '0') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Physically Hanidcapped' });
			return false;
		}
		if (this.additionaldata.distId == null || this.additionaldata.distId == '0') {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select District' });
			return false;
		}

		let acadata = [];
		this.acaDetailsInfo = [];
		let expdata = [];
		this.expDetailsInfo = [];
		acadata = this.additionaldata.academicData;
		for (let i = 0; i < acadata.length; i++) {
			if (acadata[i].academicyr == '') {
				acadata[i].academicyr = 0;
			}
			if (acadata[i].edudetail == '') {
				acadata[i].edudetail = 0;
			}
			if (acadata[i].exampass == '') {
				acadata[i].exampass = 0;
			}
			if (acadata[i].marks == '') {
				acadata[i].marks = 0.0;
			}
			const newRow = {
				academicyr: acadata[i].academicyr,
				edudetail: acadata[i].edudetail,
				exampass: acadata[i].exampass,
				id: acadata[i].id,
				parent_id: acadata[i].parent_id,
				marks: acadata[i].marks,
				subjectstudied: acadata[i].subjectstudied,
				otherinfo: acadata[i].otherinfo,
				division: acadata[i].division
			};
			this.acaDetailsInfo.push(newRow);

		}
		this.additionaldata.academicData = this.acaDetailsInfo;

		expdata = this.additionaldata.experienceData;
		for (let i = 0; i < expdata.length; i++) {
			if (expdata[i].instituteName != undefined) {
				let d1 = new Date();
				let d2 = new Date();
				if (expdata[i].fromdate != null) {
					d1 = new Date(Date.parse(expdata[i].fromdate));
				}
				if (expdata[i].todate != null) {
					d2 = new Date(Date.parse(expdata[i].todate));
				}
				const newRow = {
					id: expdata[i].id,
					parent_id: expdata[i].parent_id,
					fromdate: d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear(),
					todate: d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear(),
					instituteName: expdata[i].instituteName,
					yearcount: expdata[i].yearcount,
					typeofemployee: expdata[i].typeofemployee,
					monthcount: expdata[i].monthcount
				};
				this.expDetailsInfo.push(newRow);
			}
		}
		this.additionaldata.experienceData = this.expDetailsInfo;
		const d = new Date(Date.parse(this.additionaldata.dob));
		this.additionaldata.dob = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
		this.additionaldata.userid = localStorage.getItem('member-id');
		this.additionaldata.advid = this.advid;
		//console.log(this.additionaldata.experienceData);
		this.processbar = true;
		this.registrationService.savestaffData(this.additionaldata).then(res => {
			//console.log(res);
			this.dataList = res;
			if (this.dataList.status == 'success') {
				//alert(this.dataList.msg);
				this.msgs = [];
				this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.msg });
				this.processbar = false;
				this.getAllCandidateList();
			}
		});
		this.reset();
		//this.getAllCandidateList();
		this.showForm();
	}

	acaAddRows() {
		const newRow = {
			academicyr: '0',
			edudetail: '0',
			exampass: '0',
			id: '',
			parent_id: '',
			marks: '',
			subjectstudied: '',
			otherinfo: '',
			division: ''
		};
		this.additionaldata.academicData.push(newRow);
	}
	expAddRows() {
		const newRow = {
			id: '',
			parent_id: '',
			fromdate: '',
			todate: '',
			instituteName: '',
			yearcount: '',
			typeofemployee: '0',
			monthcount: ''
		};
		this.additionaldata.experienceData.push(newRow);
	}

	showForm() {
		this.getAllCommonList();
		this.reset();
		this.showdeleteBtn = false;
		this.additionaldata.phid = 29;
		this.additionaldata.sex = 0;
		this.displayForm = true;
		if (this.advid != 1) {
			for (let i = 0; i < 8; i++) {
				this.acaAddRows();
			}
		} else {
			for (let i = 0; i < 10; i++) {
				this.acaAddRows();
			}
		}
		let acadata = [];
		acadata = this.additionaldata.academicData;
		if (this.advid != 1) {
			acadata[0].exampass = 3;
			acadata[1].exampass = 4;
			acadata[2].exampass = 5;
			acadata[3].exampass = 7;
			acadata[4].exampass = 81;
			acadata[5].exampass = 82;
			acadata[6].exampass = 83;
			acadata[7].exampass = 6;
		} else {
			acadata[0].exampass = 3;
			acadata[1].exampass = 4;
			acadata[2].exampass = 5;
			acadata[3].exampass = 84;
			acadata[4].exampass = 7;
			acadata[5].exampass = 85;
			acadata[6].exampass = 81;
			acadata[7].exampass = 82;
			acadata[8].exampass = 83;
			acadata[9].exampass = 6;
		}

	}
	onRowSelect(event) {
		this.reset();
		this.user_id = localStorage.getItem('member-id');
		this.displayForm = true;
		this.showdeleteBtn = true;
		this.rowData = this.cloneRecForm(event.data);
		this.processbar = true;
		this.additionaldata.id = this.rowData.id;
		this.registrationService.getStaffDetails(this.rowData.id).then(res => {
			this.dataList = res;
			this.additionaldata = this.dataList.recrutmentDtls;

			this.acaDetailsInfo = [];
			let acadata = [];
			acadata = this.additionaldata.academicData;
			for (let i = 0; i < acadata.length; i++) {
				const newRow = {
					academicyr: acadata[i].academicyr,
					edudetail: acadata[i].edudetail,
					exampass: acadata[i].exampass,
					id: acadata[i].id,
					parent_id: acadata[i].parent_id,
					marks: acadata[i].marks,
					subjectstudied: acadata[i].subjectstudied,
					otherinfo: acadata[i].otherinfo,
					division: acadata[i].division
				};
				this.acaDetailsInfo.push(newRow);
			}
			this.additionaldata.academicData = this.acaDetailsInfo;

			this.expDetailsInfo = [];
			let expdata = [];
			expdata = this.additionaldata.experienceData;
			for (let i = 0; i < expdata.length; i++) {
				let d1, frdt;
				let d2, todt;
				if (expdata[i].fromdate != null) {
					d1 = new Date();
					d1 = new Date(Date.parse(expdata[i].fromdate));
					frdt = d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear();
				}
				if (expdata[i].todate != null) {
					d2 = new Date();
					d2 = new Date(Date.parse(expdata[i].todate));
					todt = d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear();
				}
				const newRow = {
					id: expdata[i].id,
					parent_id: expdata[i].parent_id,
					fromdate: frdt,
					todate: todt,
					instituteName: expdata[i].instituteName,
					yearcount: expdata[i].yearcount,
					typeofemployee: expdata[i].typeofemployee,
					monthcount: expdata[i].monthcount
				};
				this.expDetailsInfo.push(newRow);
			}
			this.additionaldata.experienceData = this.expDetailsInfo;

			const d = new Date(Date.parse(this.additionaldata.dob));
			this.additionaldata.dob = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
			for (let i = 0; i < 8 - acadata.length; i++) {
				this.acaAddRows();
			}
			if (acadata.length == 0) {
				if (this.advid != 1) {
					this.additionaldata.academicData[0].exampass = 3;
					this.additionaldata.academicData[1].exampass = 4;
					this.additionaldata.academicData[2].exampass = 5;
					this.additionaldata.academicData[3].exampass = 7;
					this.additionaldata.academicData[4].exampass = 81;
					this.additionaldata.academicData[5].exampass = 82;
					this.additionaldata.academicData[6].exampass = 83;
					this.additionaldata.academicData[7].exampass = 6;
				}
				else {
					this.additionaldata.academicData[0].exampass = 3;
					this.additionaldata.academicData[1].exampass = 4;
					this.additionaldata.academicData[2].exampass = 5;
					this.additionaldata.academicData[3].exampass = 84;
					this.additionaldata.academicData[4].exampass = 7;
					this.additionaldata.academicData[5].exampass = 85;
					this.additionaldata.academicData[6].exampass = 81;
					this.additionaldata.academicData[7].exampass = 82;
					this.additionaldata.academicData[8].exampass = 83;
					this.additionaldata.academicData[9].exampass = 6;
				}
			}
			this.processbar = false;

		});
	}

	cloneRecForm(c: FormGroup): FormGroup {
		return c;
	}

	reset() {
		this.getAllCommonList();
		this.additionaldata.id = null;
		this.additionaldata.name = null;
		this.additionaldata.email = null;
		this.additionaldata.dob = null;
		this.additionaldata.mobile = null;
		this.additionaldata.sex = null;
		this.additionaldata.address = null;
		this.additionaldata.distId = null;
		this.additionaldata.pin = null;
		this.additionaldata.designationId = null;
		this.additionaldata.departmentId = null;
		this.additionaldata.categoryId = null;
		this.additionaldata.phid = null;
		this.additionaldata.publjrnlno = null;
		this.additionaldata.publbooksno = null;
		this.additionaldata.publprocedingno = null;
		this.additionaldata.attndseminerno = null;
		this.additionaldata.attndconfno = null;
		this.additionaldata.attndworkshopno = null;
		this.additionaldata.phdguideno = null;
		this.additionaldata.researchprojno = null;
		this.additionaldata.apiscore = null;
		this.additionaldata.applicationNo = null;
		this.additionaldata.subjectsplid = null;
		this.additionaldata.academicData = [];
		this.additionaldata.experienceData = [];
		this.additionaldata.userid = null;
		this.additionaldata.postcategoryid = null;
	}
	calcDate(i, date1, date2) {
		let d1 = new Date();
		let d2 = new Date();
		d1 = new Date(Date.parse(date1));
		d2 = new Date(Date.parse(date2));
		let fdate = d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear();
		let tdate = d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear();

		this.cdt = fdate;
		this.dbm = tdate.split("/")[1];
		this.dby = tdate.split("/")[2];

		this.dby = this.dby - this.cdt.split("/")[2];
		this.dbm = this.dbm - this.cdt.split("/")[1];
		if (this.dbm < 0) {
			this.dbm = 12 + this.dbm;
			this.dby--;
		}

		let expdata = [];
		expdata = this.additionaldata.experienceData;
		if (isNaN(this.dby)) {
			this.dby = 0;
		}
		if (isNaN(this.dbm)) {
			this.dbm = 0;
		}
		expdata[i].yearcount = this.dby;
		expdata[i].monthcount = this.dbm;
	}
	removeExp(index, id) {
		if (id == '') {
			this.additionaldata.experienceData.splice(index, 1);
		} else {
			this.registrationService.deleteExperienceByid(id).then(res => {
				this.additionaldata.experienceData.splice(index, 1);
				this.dataList = res;
			});
		}
	}

	validateEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	addDistrict() {
		if (this.distName == null || this.distName == '') {
			alert("Please Enter District");
		}
		else {
			this.registrationService.addMaster('dist', this.distName).then(res => {
				console.log(res);
				this.dataList = res;
				if (this.dataList.status == 'success') {
					this.msgs = [];
					this.msgs.push({ severity: 'success', summary: 'Success Message', detail: 'District Saved Successfully.' });
					this.distName = "";
					this.getAllCommonList();
				} else if (this.dataList.status == 'failure') {
					this.msgs = [];
					this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'District Already Exist.' });
					this.distName = "";
				}
			});
		}
	}

	addBoard() {
		if (this.boardName == null || this.boardName == '') {
			alert("Please Enter Board");
		}
		else {
			this.registrationService.addMaster('board', this.boardName).then(res => {
				console.log(res);
				this.dataList = res;
				if (this.dataList.status == 'success') {
					this.msgs = [];
					this.msgs.push({ severity: 'success', summary: 'Success Message', detail: 'Board Saved Successfully.' });
					this.boardName = "";
					this.getAllCommonList();
				} else if (this.dataList.status == 'failure') {
					this.msgs = [];
					this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Board Already Exist.' });
					this.boardName = "";
				}
			});
		}
	}

	deleteRecDetailsbyId(id) {
		if (confirm("Do you want to delete?")) {
			this.processbar = true;
			this.registrationService.deleteRecDetailsbyId(id).then(res => {
				this.dataList = res;
				if (this.dataList.status == 'success') {
					this.msgs = [];
					this.msgs.push({ severity: 'success', summary: 'success Message', detail: 'Delete Successfully' });
					this.getAllCandidateList();
					this.processbar = false;
					this.displayForm = false;
				}
			});
		}
	}
	printbiodata(flg) {
		console.log(this.designationId);
		if (this.designationId.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		// if (this.advid != 1) {
		// 	if (this.departmentId.id == undefined) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		if (this.postcategoryid.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		let data = {
			pid: this.designationId.id,
			pcid: this.postcategoryid.id,
			did: this.departmentId.id,
			pname: this.designationId.name,
			pcname: this.postcategoryid.name,
			dname: this.departmentId.name,
			userid: localStorage.getItem('member-id')
		}
		if (confirm("Do you want to Print?")) {
			this.processbar = true;
			this.registrationService.printForm(data, flg,this.advid).then(res => {
				this.dataList = res;
				if (this.dataList.status == 'success') {
					window.open(this.dataList.staffRecPdflink);
				} else {
					alert("Data not found");
				}
				this.processbar = false;
			});
		}
	}

	printscoresheet(flg) {
		if (this.designationId.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		// if (this.advid != 1) {
		// 	if (this.departmentId.id == undefined) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		if (this.postcategoryid.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		let data = {
			pid: this.designationId.id,
			pcid: this.postcategoryid.id,
			did: this.departmentId.id,
			pname: this.designationId.name,
			pcname: this.postcategoryid.name,
			dname: this.departmentId.name,
			userid: localStorage.getItem('member-id')
		}
		if (confirm("Do you want to Print?")) {
			this.processbar = true;
			this.registrationService.printscoresheet(data, flg, this.advid).then(res => {
				console.log(res);
				this.dataList = res;
				if (this.dataList.status == 'success') {
					window.open(this.dataList.staffRecPdflink);
				} else {
					alert("Data not found");
				}
				this.processbar = false;
			});
		}
	}

	printCandidateListByPost() {
		if (this.designationId.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		// if (this.advid != 1) {
		// 	if (this.departmentId.id == undefined) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		if (this.postcategoryid.id == undefined) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		let data = {
			pid: this.designationId.id,
			pcid: this.postcategoryid.id,
			did: this.departmentId.id,
			pname: this.designationId.name,
			pcname: this.postcategoryid.name,
			dname: this.departmentId.name,
			userid: localStorage.getItem('member-id')
		}
		if (confirm("Do you want to Print?")) {
			this.processbar = true;
			this.registrationService.printCandidateListByPost(data,this.advid).then(res => {
				this.dataList = res;
				if (this.dataList.status == 'success') {
					window.open(this.dataList.staffRecPdflink);
				} else {
					alert("Data not found");
				}
				this.processbar = false;
			});
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/staffrecruitment/staffrecruitment.component.ts